const sayings = [
  "Cayley, you are absolutely crushing it.",
  "Every completed step is another tiny victory parade.",
  "The shop floor sees the magic. Keep going.",
  "That number is not luck. That is momentum.",
  "Cayley mode: focused, fast, unstoppable.",
  "More finished work. More proof. More confetti."
];

const root = document.querySelector("[data-celebration-api]");
const countElement = document.querySelector("[data-count]");
const sayingElement = document.querySelector("[data-saying]");
const metaElement = document.querySelector("[data-meta]");

let sayingIndex = 0;

function setSaying() {
  if (!sayingElement) return;
  sayingElement.textContent = sayings[sayingIndex % sayings.length];
  sayingIndex += 1;
}

function formatNumber(value) {
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(value);
}

function describeLatest(value) {
  if (!value) return "Latest completion time is waiting for the next fresh snapshot.";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Latest completion time is in the snapshot.";
  return `Latest Cayley completion: ${date.toLocaleString([], {
    dateStyle: "medium",
    timeStyle: "short"
  })}.`;
}

async function loadCelebration() {
  if (!root || !countElement || !metaElement) return;
  try {
    const response = await fetch(root.getAttribute("data-celebration-api"), {
      headers: { accept: "application/json" }
    });
    if (!response.ok) {
      throw new Error(`Celebration API returned ${response.status}`);
    }
    const data = await response.json();
    const completedWorkCount = Number(data.completedWorkCount ?? 0);
    countElement.textContent = formatNumber(completedWorkCount);
    metaElement.textContent = `${data.countedUnit ?? "Completed Jobs"} counted for ${
      data.displayName ?? "Cayley"
    }. ${describeLatest(data.latestCompletedAt)}`;
  } catch {
    countElement.textContent = "!";
    metaElement.textContent = "The celebration counter could not load yet. Cayley is still doing great.";
  }
}

setSaying();
window.setInterval(setSaying, 4200);
void loadCelebration();
